import { Box, Button, CircularProgress, Grid, Hidden, IconButton, Stack, Tab, Tabs, TextField, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { dataUtil, getProductPricePrimary, usage_type } from '../../wsclient/crmservices/dataUtil';
import Container from '../../components/Container';
import SubHeader from '../../components/SubHeader';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import CardComponent from '../../components/Card';
import { getCurrencySymbol, getLogoImage } from '../../utils/common';
import { makeStyles } from '@mui/styles';
import { cache, order_key } from '../../utils/cache';
import Paging from '../../components/Paging';
import { CloseCircleIcon, CloseLineIcon, FilterIcon, iconFontSize, SearchIcon } from '../../components/IconComponent';
import Modal from '../../components/Modal';
import { formatAmount } from '../../utils/util';
import { portal_config } from '../../portal.config';
import ResponsiveImages from '../../components/ReponsiveImages';
import BoxContent from '../../components/BoxContent';
import CartComponent from '../../components/CartComponent';
import { GetIconColor } from '../../theme/main_style';
import { Field, Form } from 'react-final-form';
import { TextFieldCustom } from '../../components/FormElements';

const useStyles = makeStyles((theme) => ({
    cart_image_contain: (props) => {
        return ({
            borderRadius: '0.75rem',
            height: 100,
            width: 100,
            border: 'none',
            objectFit: 'cover',
            border: '1px solid ' + props.palette.border.main,
        })
    },
}))
export default function MenuItemsView(props) {
    const [showSearch, setShowSearch] = useState(false)
    const [value, setValue] = useState(null);
    const [categoryValue, setCategoryValue] = useState(0);
    const [subCategoryValue, setSubCategoryValue] = useState(0);
    const appConfig = cache.getAppConfig();
    const [showAllDesc, setShowAllDesc] = useState(false);
    let isDarkMode = appConfig && appConfig.appearance && appConfig.appearance.dark_mode;

    useEffect(() => {
        if(value && !props.openSearch){
            props.searchProducts(null);
            setValue(null)
        }}, [props.openSearch])

    const handleChangeCategory = (event, newValue) => {
        setCategoryValue(newValue);
        setSubCategoryValue(0);
        props.onSelectCategory(categories[newValue]);
    };

    const handleChangeSubCategory = (event, newValue) => {
        setSubCategoryValue(newValue);
        props.onSelectSubCategory(subCategories[newValue]);
    };
    const { storeName, storeAddress, storePhone, categories, subCategories, menuItems, showCatalogDesc} = props;
    const { t } = useTranslation();
    const { palette, breakpoints } = useTheme();
    const cartItems = cache.getCartItem();
    const totalCartItem = dataUtil.getTotalCartQuantity(cartItems ? cartItems : []);

    const onClickItemSearch = async (product) => {
        setShowSearch(false);
        await props.onClickItem(product, true);
    }

    const processContentWithURL = (content) => {
        const isHTML = (str) => !(str || '')
            // replace html tag with content
            .replace(/<([^>]+?)([^>]*?)>(.*?)<\/\1>/ig, '')
            // remove remaining self closing tags
            .replace(/(<([^>]+)>)/ig, '')
            // remove extra space at start and end
            .trim();
        if (content && !isHTML(content)) {
            let urlRegex = /(https?:\/\/[^\s]+)/g;
            content = content.replace(urlRegex, function (url) {
                return '<a href="' + url + '">' + url + '</a>';
            })
        }
        if(content && content.length > 0){
            content = content.replaceAll(/\n/g, '<br>')
        }
        return content;
    }


    let catalog_selected = localStorage.getItem(order_key.catalog_selected);
    let short_desc = null;
    if (showCatalogDesc && catalog_selected) {
        catalog_selected = JSON.parse(catalog_selected);
        short_desc = catalog_selected && catalog_selected.description ? processContentWithURL(catalog_selected.description).replaceAll('\n', '<br/>').slice(0, 100) : null;
        let hasMore = false;
        if(short_desc && catalog_selected.description.length > 200){
            short_desc += '...';
            hasMore = true;
        }
    }

    return (
        <Container
            showHeader={true}
            subHeader={<SubHeader title={storeName} subtitle={storeAddress} subtitle2={storePhone ? "Phone: " + storePhone : null}/>}
            hideSubHeaderXs={true}
            showProcessing={props.showProcessing}
            showFooter={true}
            message={props.message}
            mobileHeader={{
                show: true,
                title: storeName,
                onBack: props.onBack,
                right:<>
                    <IconButton onClick={() => props.setOpenSearch(!props.openSearch)}>
                        <SearchIcon color={palette.primary.main}/>
                    </IconButton>
                    {props.showFilter &&
                    <IconButton onClick={() => props.onOpenFilter()}>
                        <FilterIcon color=""/>
                    </IconButton>}
                    </>
            }}
        >

            {showCatalogDesc && catalog_selected && catalog_selected.description &&
                <BoxContent noPaddingX>
                    {showAllDesc ? 
                        <Typography onClick={() => setShowAllDesc(false)} variant="subtitle2" dangerouslySetInnerHTML={{ __html: processContentWithURL(catalog_selected.description) }}/>
                        :
                        <Typography onClick={() => setShowAllDesc(true)}  variant="subtitle2"  dangerouslySetInnerHTML={{ __html: short_desc }}/>
                    }
                </BoxContent>
            }

            <BoxContent noPaddingX sx={{ display: 'flex', alignItems: 'center' }}>
                <Hidden mdUp>
                    <CartComponent
                        reloadFunc={props.reloadFunc}
                        loading={props.showLoading || props.showLoadingCategories}
                        includeOrderMethod
                        from="menu_items"
                        redirect_path={props.redirectPath}
                        />
                </Hidden>
                <Hidden mdDown>
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Box sx={{ flexBasis: '90%', flexShrink: 0 }}>
                            <CartComponent
                                reloadFunc={props.reloadFunc}
                                loading={props.showLoading || props.showLoadingCategories}
                                includeOrderMethod
                                from="menu_items"
                                redirect_path={props.redirectPath}
                            />
                        </Box>
                        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
                            {!props.openSearch &&
                            <IconButton onClick={() => props.setOpenSearch(true)} sx={{ ml: 2 }}>
                                <SearchIcon color={GetIconColor().primary} />
                            </IconButton>}
                            {props.showFilter &&
                            <IconButton onClick={() => props.onOpenFilter()}>
                                <FilterIcon color=""/>
                            </IconButton>}
                        </Box>
                    </Box>
                </Hidden>
                {props.openSearch && 
                    <Grid item xs={12}>
                        <Form
                            onSubmit={props.searchProducts}
                            render={({ handleSubmit }) => (
                                <Grid item xs={12}>
                                    <Grid item xs={12} marginY={2}>
                                        <Field
                                            name="search_offers"
                                            component={TextFieldCustom}
                                            xs={{color: palette.text.primary}}
                                            classes={{backgroundColor: palette.background.main,borderRadius: 16}}
                                            placeholder={t('search_products_placeholder')}
                                            isEdit={true}
                                            initialValue={value}
                                            onCustomChange={async (value) =>{
                                                setValue(value);
                                                if(value == null || value == ''){
                                                    props.searchProducts(null);
                                            }}}
                                            endAdornment={
                                            <Box sx={{ display: 'flex',}}>
                                                <Stack sx={{ cursor: 'pointer', ml:4 }} onClick={() => props.searchProducts(value)}>
                                                    <SearchIcon color={GetIconColor().default}/>
                                                </Stack>
                                                <Stack sx={{ cursor: 'pointer', ml:4  }} onClick={() => {props.setOpenSearch(false) ;  props.searchProducts(null);}}>
                                                    <CloseCircleIcon color={GetIconColor().default}/>
                                                </Stack>
                                            </Box>
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            )} />
                    </Grid>
                }

            </BoxContent>

            {props.filterSelected && props.filterSelected.brand_id && props.filterSelected.brand_id[0].id !== 'ALL' &&
                <Stack direction={'row'} mt={2} mr={1}>
                        <Stack direction={'row'} spacing={1} alignItems='center'>
                            <Typography variant="subtitle2" color={palette.text.primary}>{t('brand')}: </Typography>
                            {props.filterSelected.brand_id.map((item, index) => {
                                return (
                                    <Button 
                                        endIcon={<CloseLineIcon size={iconFontSize.xs} color={GetIconColor().primary} />}
                                        variant="outlined"
                                        sx={{
                                            padding: "5px 15px",
                                            backgroundColor: palette.background.main,
                                            '&:hover': {
                                                backgroundColor: palette.background.main,
                                                color: palette.primary.main,
                                            },
                                        }}
                                        onClick={() => props.onSelectFilter("brand_id", item)}>{item.name}
                                    </Button>
                                )})
                            }
                        </Stack>
                    
                </Stack>}

            <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                {(!props.filteredProducts) &&  <Box
                    sx={{
                        position: 'sticky',
                        zIndex: 10,
                        backgroundColor: isDarkMode ? '#121212' : '#fff',
                        boxShadow: '0px 4px 6px -4px rgba(0,0,0,0.2)',
                        paddingY: 1,
                        [breakpoints.down('md')]: {
                            top: 50, 
                        },
                        [breakpoints.up('md')]: {
                            top: 0, 
                        },
                    }}
                    borderBottom={4}
                    borderColor={palette.border.card}
                >
                    <>
                    {categories && categories.length > 0 ? (
                        <>
                        <Tabs
                            value={categoryValue}
                            onChange={handleChangeCategory}
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs categories"
                            sx={{ '& .MuiTabs-indicator': { display: 'none' } }}
                        >
                            {categories.map((item, index) => {
                                return (
                                    <Tab key={index} label={item.name}
                                        sx={{
                                            marginRight: 2,
                                            borderRadius: 32,
                                            minHeight: 32,
                                            height: 36,
                                            border: 'none',
                                            boxShadow: index == categoryValue ? (isDarkMode? '1px 2px 10px -6px rgba(255, 255, 255, 0.75)'  : '1px 2px 10px -6px rgba(0,0,0,0.75)') : undefined,
                                            fontWeight: index == categoryValue ? 'bold' : 'medium',
                                            transition: 'all 0.3s ease 0s',
                                            color: index == categoryValue ? palette.primary.main : palette.textMenuCustom.main
                                        }}
                                    />
                                )
                            })}
                        </Tabs>
                        <Tabs
                            value={subCategoryValue}
                            onChange={handleChangeSubCategory}
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs subcategories"
                            sx={{ '& .MuiTabs-indicator': { display: 'none' } }}
                        >
                            {subCategories.map((item, index) => {
                                return (
                                    <Tab key={index} label={item.name}
                                        sx={{
                                            marginRight: 2,
                                            minHeight: 32,
                                            height: 36,
                                            border: 'none',
                                            fontWeight: index == subCategoryValue ? 'bold' : 'medium',
                                            color: index == subCategoryValue ? palette.primary.main : palette.textMenuCustom.main,
                                        }}
                                    />
                                )
                            })}
                        </Tabs>
                        </>
                    ) : (
                        <Typography variant="subtitle1">{t('no_categories_to_display')}</Typography>
                    )}
                    </>
                </Box>}

                <Box sx={{ flex: 1, overflowY: 'auto', padding: 2 }}>
                    {props.showLoading || props.showLoadingCategories ? (
                    <Grid item xs={12} container justifyContent="center" alignItems="center">
                        <CircularProgress />
                    </Grid>
                    ) : (
                    <>
                        {menuItems && menuItems.length > 0 ? (
                        <>
                            <Grid container spacing={2}>
                            {menuItems.map((item, index) => (
                                <ProductItem key={index} item={item} onClickItem={props.onClickItem} />
                            ))}
                            </Grid>
                            <Paging
                            paging={props.paging}
                            handleChangePage={props.handleChangePage}
                            handleChangeRowsPerPage={props.handleChangeRowsPerPage}
                            />
                        </>
                        ) : (
                        <Typography variant="subtitle1">{t('no_products_to_display')}</Typography>
                        )}
                    </>
                    )}
                </Box>
            </Box>            
{/* 
            {showSearch && <Modal maxWidth={'sm'} isOpen={showSearch} title={t('search_products')} onClose={() => setShowSearch(false)} enableCloseButton>
                <Grid item xs={12}>
                    <TextField
                        name='menuItems/search'
                        id='menuItems/search'
                        InputProps={{
                            startAdornment: <Box pr={1}><SearchIcon /></Box>
                        }}
                        placeholder={t('search_products_placeholder')}
                        onChange={(e) => props.onHandleChange(e.target.value)}
                        defaultValue={props.searchValue}
                    />
                </Grid>
                <Box maxHeight={'50vh'} overflow='auto' my={2}>
                    {props.showLoadingSearch && <center><CircularProgress /></center>}
                    {props.searchMenuItems && <Grid xs={12} item spacing={2}>
                        {props.searchMenuItems.map((item, index) => {
                            return (
                                <Box key={index} py={1}>
                                    <ProductItem key={index} item={item} onClickItem={onClickItemSearch} />
                                </Box>
                            )
                        })}
                    </Grid>}
                </Box>
            </Modal>} */}
        </Container>
    )
}

function ProductItem(props) {
    const { item } = props;
    let isAvailable = item.availability === 'ENABLED' ? true : false;
    let pricePrimary = getProductPricePrimary(item.pricing);
    let currency = null;
    if (pricePrimary) {
        currency = getCurrencySymbol(pricePrimary.currency ? pricePrimary.currency : null);
    }
    if (!currency) {
        currency = cache.getCurrency();
    }
    return (
        <Grid data-test={"product-"+item.id} item xs={12} sm={6} onClick={() => props.onClickItem(item)} sx={{
            cursor: 'pointer'
        }}>
            <CardComponent noBorder>
                <Stack direction={'row'} flex={1} spacing={2} sx={{ opacity: isAvailable ? 1: 0.5  }}>
                    <Stack sx={{
                        width: 100,
                    }}>
                        <ProductImage image={dataUtil.getImageByUsageType(item.creatives, usage_type.product_item)} />
                    </Stack>
                    <Stack paddingRight={1} paddingY={1} sx={{
                        width: 'calc(100% - 100px - 24px)',
                        position: 'relative'
                    }}>
                        <Typography variant='subtitle1' sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '100%'
                        }}>
                            {item.name}
                        </Typography>
                        <Typography variant='subtitle2' sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: 'calc(100% - 8px)',
                        }}>{item.description}</Typography>

                        <Typography variant='subtitle1' sx={{
                            position: 'absolute',
                            bottom: '8px'
                        }}>{currency}{formatAmount(dataUtil.getProductPrice(item.pricing), portal_config.isFormatDecimalBalance)}</Typography>
                    </Stack>
                </Stack>
            </CardComponent>
        </Grid>
    )
}

function ProductImage(props) {
    const theme = useTheme();
    const currentStyle = useStyles(theme);
    let logoImage  = getLogoImage();
    if (props.image && props.image.length > 0) {
        // return <img src={props.image.url} className={currentStyle.image_contain} />
        return <ResponsiveImages media={props.image} classes={currentStyle.cart_image_contain} size='medium' componentWidth={100} />
    } return <img alt='Product Image' src={logoImage} classes={currentStyle.cart_image_contain}/>
    // return <Box className={currentStyle.cart_image_contain} />;
}
